import { FeatureConfig } from '@typesApp/Config'
import { ViewName, ViewNavigation } from '@typesApp/ViewNavigation'

export const baseConfig_CAFlow: FeatureConfig = {
  disableAuthTokenForGuest: true,
  contactUs: ['phone', 'chat', 'faq'],

  defaultView: 'intro',

  // view navigation configuration
  viewNavigation: {
    loginRedirectView: 'intro',

    // next and previews flow
    flow: {
      intro: {
        next: 'insurance-information',
      },
      'insurance-information': {
        next: 'select-prescription',
        previous: 'intro',
      },
      insurers: {
        next: 'insurance-information',
        previous: 'intro',
      },
      'select-prescription': {
        next: 'select-product',
        previous: 'insurance-information',
      },
      'select-product': {
        next: 'review',
        previous: 'select-prescription',
      },
    } as Record<ViewName, ViewNavigation>,

    // all steps in insurance flow
    steps: ['insurance-information', 'select-prescription', 'select-product', 'review'],

    // CA flow has 3 dynamic forms within insurance-information view
    stepsOffset: 3,

    // show progress indicator
    showSteps: true,

    // resume view mapping
    resumeMapping: {
      // default resume to insurance form
      '*': 'insurance-information',

      // resume by claim record status and qualifier
      CLAIM_SUBMITTED: 'review',
      PRESCRIPTIONS_APPROVED: 'review',
      PRESCRIPTIONS_AUTO_APPROVED: 'review',
      PRESCRIPTIONS_DISAPPROVED: 'review',
      PRESCRIPTIONS_FOR_REVIEW: 'review',
      PRESCRIPTIONS_IN_REVIEW: 'review',
      READY_TO_CLAIM: 'review',
      'PRESCRIPTIONS_REQUIRED:HAS_REFERRER_NO_PRESCRIPTION': 'select-prescription',
      'PRESCRIPTIONS_FOR_REVIEW:NO_PRODUCT_INCLUDED_IN_PRESCRIPTION': 'select-product',
      'PRESCRIPTIONS_REQUIRED:HAS_REFERRER_WITH_PRESCRIPTION': 'select-product',
      'READY_TO_CLAIM:NO_PRODUCT_INCLUDED_IN_PRESCRIPTION': 'select-product',
      'PRESCRIPTIONS_REQUIRED:VALIDATE_PRESCRIPTION_IN_PROGRESS': 'validate',
    },
  },
}
